import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f540da80&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f540da80&prod&lang=css&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=f540da80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f540da80",
  null
  
)

export default component.exports